import * as React from 'react';
import { StyledBottomBar, BottomBarBackground } from '../styles';
import ShareButton from '../../../containers/Share/ShareButton';
import { ShareOrigin } from '../../../containers/Share/actions';
import { Api } from '../../../typings/api';
import FolderCreator from '../../../containers/FolderCreatorFromSelection';

interface PageProps {
	selection: Api.DriveItem[];
	showFolderCreation: boolean;
}

const PageBottomBar = (props: PageProps) => {
	const { selection, showFolderCreation } = props;

	return (
		<StyledBottomBar>
			<BottomBarBackground>
				{showFolderCreation &&
					<FolderCreator />
				}
				<ShareButton
					shareOrigin={ShareOrigin.Selection}
					driveItems={selection}
					isInBottomBar={true}
				/>
			</BottomBarBackground>
		</StyledBottomBar>
	);
};

export default PageBottomBar;


// WEBPACK FOOTER //
// ./node_modules/tslint-loader!./src/components/Page/BottomBar/index.tsx